import { DateTime } from 'luxon';

export const processCancelacionResponse = (payload) => {
  const cancelacionModel = {};
  const relationships = payload.data.relationships;
  const included = payload.included;
  if (included && included.length > 0) {
    included.forEach((rel) => {
      if (rel.type === 'node--date_assignement') {
        cancelacionModel.fechaCancelacion =
          DateTime.fromISO(rel.attributes.f_firma_cancelacion).setLocale('es').toFormat("yyyy-MM-dd'T'HH:mm:ss.SSS");
      }
      if ('notario_cancelacion' in relationships && rel.type === 'node--notary') {
        cancelacionModel.title = rel.attributes.title;
        cancelacionModel.nombre = rel.attributes.nt_nombre;
        cancelacionModel.apellidos = rel.attributes.nt_apellidos;
        cancelacionModel.id = rel.attributes.uuid;
      }
    });
    return cancelacionModel;
  }
  return {};
};
export const formatOperationNotary = (operationModel) => {
  const relationships = {};
  if (operationModel.notaryModel) {
    relationships.notario_cancelacion = {
      data: {
        type: 'node--notary',
        id: operationModel.notaryModel.id,
      },
    };
  }
  return {
    data: {
      id: operationModel.op,
      type: 'node--operation',
      relationships,
    },
  };
};
export const formatDatesAssigments = (datesModel) => {
  const attributes = {};
  if (datesModel.notaryModel.fechaCancelacion) {
    attributes.f_firma_cancelacion = DateTime.fromISO(datesModel.notaryModel.fechaCancelacion).setLocale('es').toFormat("yyyy-MM-dd'T'HH:mm:ss");
  }
  return {
    data: {
      id: datesModel.date,
      type: 'node--date_assignement',
      attributes,
    },
  };
};



// WEBPACK FOOTER //
// ./src/features/cancelacion/utils.js